// @flow
import { css } from 'styled-components';

/*
Common for all side panel icons
*/

const sidePanelTitleIconCss = css`
  overflow: visible;
  height: 63px;
  width: 63px;
  
`;

export default sidePanelTitleIconCss;
